/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as openpgp from '../../../../assets/js/openpgp.min.mjs'
import * as _ from 'lodash';
import { Observable, throwError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  private pgpKeys: any = {
    public_key: '',
    private_key: '',
    passphrase: ''

  }
  constructor(
    public _http: HttpClient,

  ) { 
  }

  initializePGP() {
    const params = {
      protocol: environment.webPrivateV1.protocol,
      port: environment.webPrivateV1.port,
      apiPrefix: (environment.host != "localhost") ? "/rateus" : ""
    }
      const promise = [
        new Promise((resolve, reject) => {
          this._http.get(this.apiUrlGeneration(params, "/pv-key"),{responseType: 'text'}).subscribe(res => {
            resolve(res);
          }, error => {
            console.error("Error getting pv-key", error);
            reject(error);
          })
        }),
        new Promise((resolve, reject) => {
          this._http.get(this.apiUrlGeneration(params, "/pb-key"),{responseType: 'text'}).subscribe(res => {
            resolve(res);
          }, error => {
            console.error("Error getting pb-key", error);
            reject(error);
          })
        }),
        new Promise((resolve, reject) => {
          this._http.get(this.apiUrlGeneration(params, "/pv-phrase"),{responseType: 'text'}).subscribe(res => {
            resolve(res);
          }, error => {
            console.error("Error getting pv-phrase", error);
            reject(error);
          })
        }),
      ]
      Promise.all(promise).then(([privateKey, publicKey, passphrase]) => {
        this.pgpKeys = {
          private_key: privateKey,
          public_key: publicKey,
          passphrase: passphrase
        }
      }).catch((error) => {
        console.error("Error initializing PGP", error);
      })
    
  }

  apiUrlGeneration(param1: any, param2: any) {
    let host = 'localhost'
    host = environment.host
    return `${param1.protocol}://${host}:${param1.port}${param1.apiPrefix}${param2}`;
  }

  setHeaders() {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    return options;
  }

  setHeaderWithParams(param: any) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    const options = { headers, params: this.convertObjectToQueryParams(param) };

    return options;
  }


  getAPICall(url: string, headers: any) {
    return this._http.get(url, headers)
      .pipe(map(res => {
        return Object(res);
      }
      ));
  }

  getAPICallWithBody(url: string, params: any, body: any) {
    return this._http.request("GET", url, {
      params: params,
      body: body,
      responseType: 'json'
    }).pipe(map(res => {
      return Object(res);
    }
    ));
  }

  objToQueryParams(params) {
    return Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
  }
  convertObjectToQueryParams(params) {
    let queryParam = new HttpParams();
    if (!_.isEmpty(params)) {
      _.each(params, (value: any, key: string) => {
        if (!_.isEmpty(value) || !_.isNull(value)) {
          if (value instanceof Array) {
            value.forEach((item) => {
              if (!_.isEmpty(item) || !_.isNull(item)) {
                if (typeof item == 'string' || typeof item == 'number') {
                  queryParam = queryParam.append(`${key.toString()}[]`, item);
                } else {
                  queryParam = queryParam.append(`${key.toString()}`, JSON.stringify(item));
                }
              }
            });
          } else if (!(value instanceof Array) && value instanceof Object) {
            queryParam = this.updateQueryParams(queryParam, key, value);
          } else {
            queryParam = queryParam.append(key.toString(), value);
          }
        }
      })
    }
    return queryParam;
  }
  updateQueryParams(queryParam: any, key: string, value: any) {
    _.each(value, (value1: any, key1: string,) => {
      if (!_.isEmpty(value1) || !_.isNull(value1)) {
        if (value1 instanceof Array) {
          value1.forEach((item) => {
            if (!_.isEmpty(item) || !_.isNull(item)) {
              if (typeof item == 'string' || typeof item == 'number') {
                queryParam = queryParam.append(`${key.toString()}[${key1.toString()}][]`, item);
              } else {
                queryParam = queryParam.append(`${key.toString()}[${key1.toString()}]`, JSON.stringify(item));
              }
            }


          })

        } else if (!(value1 instanceof Array) && value1 instanceof Object) {
          queryParam = this.updateQueryParams(queryParam, `${key.toString()}[${key1.toString()}]`, value1)
        } else {
          queryParam = queryParam.append(`${key.toString()}[${key1.toString()}]`, value1);
        }
      }

    })
    return queryParam;
  }

  postAPICall(url: string, body: any, headers: any) {
    return this._http.post(url, body, headers)
      .pipe(map(res => {
        return Object(res);
      }
      ));
  }

  putAPICall(url: string, body: any, headers: any) {
    return this._http.put(url, body, headers)
      .pipe(map(res => {
        return Object(res);
      }
      ));
  }

  deleteAPICall(url: string, body: any, headers: any) {
    if (headers && headers.params) {
      // Handle case when setHeaderWithParams is used (has query params)
      return this._http.delete(url, { 
        headers: headers.headers, 
        params: headers.params, 
        body: body 
      })
      .pipe(map(res => {
        return Object(res);
      }));
    } else {
      // Handle case when setHeaders is used (no query params)
      return this._http.delete(url, { headers: headers, body: body })
        .pipe(map(res => {
          return Object(res);
        }
        ));
    }
  }

  async encryptDataPGP(reqBody) {
    if(this.pgpKeys.public_key == '' || this.pgpKeys.private_key == '' || this.pgpKeys.passphrase == '') {
      this.initializePGP();
    }
    const publicKey = await this.getRequestPublicKey()

    return await openpgp.encrypt({
      message: await openpgp.createMessage({ text: JSON.stringify(reqBody) }), // input as Message object
      encryptionKeys: publicKey
    })
  }

  async decryptDataPGP(dataToDecrypt) {
    if(this.pgpKeys.public_key == '' || this.pgpKeys.private_key == '' || this.pgpKeys.passphrase == '') {
      this.initializePGP();
    }
    const message = await openpgp.readMessage({
      armoredMessage: dataToDecrypt // parse armored message
    });

    const privateKey = await this.getResponsePrivateKey()

    const { data: decrypted } = await openpgp.decrypt({
      message,
      decryptionKeys: privateKey
    });

    return JSON.parse(decrypted)

  }

  async getRequestPublicKey() {
    return await openpgp.readKey({ armoredKey: this.pgpKeys.public_key });
  }

  async getResponsePrivateKey() {
    return await openpgp.decryptKey({
      privateKey: await openpgp.readPrivateKey({ armoredKey: this.pgpKeys.private_key }),
      passphrase: this.pgpKeys.passphrase
    });

  }

  getProp(obj: any, str: any) {
    str = str.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    str = str.replace(/^\./, ''); // strip a leading dot
    var a = str.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (obj && typeof obj == 'object') {
        if (k in obj) {
          obj = obj[k];
        } else {
          return;
        }
      } else {
        return;
      }
    }
    return obj;
  }

  upload(url: string, param: any, header: any, method?: string,) {
    if (url && url != '' && !_.isEmpty(param)) {
      method = method || 'POST';
      const body = new FormData();
      console.log("upload params", param)
      if (param.fileFormDataName && param.fileFormDataName != '' && typeof param.file == 'object') {
        body.append(param.fileFormDataName, param.file)
        delete param.fileFormDataName;
        delete param.file;
      }
      for (let key in param) {
        if (param[key]) {
          body.append(key, param[key]);
        }
      }
      if (method == 'POST' || method == 'post') {
        return this._http.post(url, body, header).pipe(map(res => { return Object(res); }));
      } else if (method == 'PUT' || method == 'put') {
        return this._http.post(url, body, header).pipe(map(res => { return Object(res); }));
      } else {
        return this._http[method.toLocaleLowerCase()](url, body, header).pipe(map(res => { return Object(res); }));
      }
    } else {
      return throwError('Required parameter not passed in upload function');
    }
  }


}
